<template>
  <div
    v-if="data"
    class="basic_wrap play-page"
  >
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit van-ellipsis">
        {{ $t('sky.ying') }}
        <!-- {{ getVideoTitle(data) }} -->
      </div>
    </div>

    <div class="movie-content">
      <section class="player-card">
        <video
          ref="videoPlayer"
          class="video-js vjs-default-skin"
          webkit-playsinline="false"
          role="application"
          tabindex="-1"
          preload="auto"
          playsinline="playsinline"
          controls
          controlslist="nofullscreen"
          autoplay="autoplay"
          width="100%"
        />
      </section>

      <section class="movie-descript">
        <!--  <div class="video-name">
          {{ getVideoTitle(data) }}
        </div> -->
        <span class="play-pill">
          <van-icon name="play-circle-o" />
          {{ data.pnum }} {{ $t('sky.play') }}
        </span>
      </section>

      <section class="movie-body">
        <div class="movie-title">
          <van-icon name="fire-o" />
          <span>{{ $t('sky.retui') }}</span>
        </div>
        <div
          v-if="list"
          class="hotlist"
        >
          <article
            v-for="item in list"
            :key="item.id"
            class="hot-card"
            @click="tovideo(item.id)"
          >
            <img
              :src="formatAssetUrl(item.pic)"
              alt=""
            >
            <div class="hot-meta">
              <van-icon name="play-circle-o" />
              <span>{{ $t('sky.play') }}: {{ item.pnum }}</span>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div
      v-if="showWatchTip"
      class="watch-mask"
    >
      <div class="watch-dialog">
        <div class="watch-title">
          <span>{{ $t('sky.watchVideoTitle') }}</span>
          <button
            type="button"
            class="watch-close"
            aria-label="close"
            @click="closeshowtip"
          >
            <van-icon name="cross" />
          </button>
        </div>
        <div class="watch-content">
          {{ $t('sky.watchVideoTrialTip') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";

Vue.use(Icon);

export default {
	name: "Vplay",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: null,
			loading: false,
			page: 1,
			list: null,
			player: null,
			adSkipSeconds: 0,
			trialLimitSeconds: 20,
			trialStartTime: 0,
			maxWatchedTime: 0,
			isResettingSeek: false,
			trialStopped: false,
			cur: 0,
			area: null,
			arealist: null,
			locationsel: false,
			type: 0,
			finished: false,
			empty: false,
			showWatchTip: false,
		};
	},
	created() {
		this.$parent.footer("video", true);
	},
	mounted() {
		this.initPlayer();
		this.start();
		this.showWatchTip = true;
	},
	beforeDestroy() {
		if (this.player) {
			this.player.off("loadedmetadata", this.skipOpeningAd);
			this.player.off("timeupdate", this.limitTrialPlay);
			this.player.off("seeking", this.preventSeek);
			this.player.off("play", this.preventTrialReplay);
			this.player.dispose();
			this.player = null;
		}
	},
	beforeRouteUpdate(to, from, next) {
		next();
		this.showWatchTip = true;
		this.video(to.params.code);
	},
	methods: {
		formatAssetUrl,
		getVideoTitle(item) {
			var title = item && item.title !== undefined && item.title !== null ? String(item.title).trim() : "";

			return title || this.$t("sky.ying");
		},
		closeshowtip() {
			this.showWatchTip = false;
			if (this.trialStopped) {
				this.$router.push("/vindex");
			}
		},
		initPlayer() {
			if (this.player || !this.$refs.videoPlayer) {
				return;
			}
			this.player = videojs(this.$refs.videoPlayer, {
				controls: true,
				autoplay: false,
				preload: "auto",
				fluid: true,
			});
			this.player.on("loadedmetadata", this.skipOpeningAd);
			this.player.on("timeupdate", this.limitTrialPlay);
			this.player.on("seeking", this.preventSeek);
			this.player.on("play", this.preventTrialReplay);
		},
		setVideoSource(url) {
			if (!url) {
				return;
			}
			if (!this.player) {
				this.initPlayer();
			}
			var type = /\.m3u8($|\?)/i.test(url) ? "application/x-mpegURL" : "video/mp4";
			this.adSkipSeconds = 0;
			this.trialStartTime = 0;
			this.maxWatchedTime = 0;
			this.trialStopped = false;
			this.isResettingSeek = false;
			this.player.pause();
			this.player.src({
				src: url,
				type: type,
			});
			this.loadAdSkipSeconds(url);
			this.player.load();
			var promise = this.player.play();
			if (promise && promise.catch) {
				promise.catch(() => {});
			}
		},
		loadAdSkipSeconds(url) {
			if (!/\.m3u8($|\?)/i.test(url)) {
				return;
			}
			this.getOpeningAdSeconds(url).then(seconds => {
				this.adSkipSeconds = seconds;
				this.trialStartTime = seconds || 0;
				this.maxWatchedTime = this.trialStartTime;
				this.skipOpeningAd();
			}).catch(() => {
				this.adSkipSeconds = 0;
				this.trialStartTime = 0;
				this.maxWatchedTime = 0;
			});
		},
		skipOpeningAd() {
			if (!this.player || !this.adSkipSeconds || this.player.currentTime() >= this.adSkipSeconds) {
				return;
			}
			this.isResettingSeek = true;
			this.maxWatchedTime = this.adSkipSeconds;
			this.player.currentTime(this.adSkipSeconds);
			setTimeout(() => {
				this.isResettingSeek = false;
			}, 100);
		},
		getTrialEndTime() {
			return this.trialStartTime + this.trialLimitSeconds;
		},
		limitTrialPlay() {
			if (!this.player) {
				return;
			}
			var currentTime = this.player.currentTime();
			var endTime = this.getTrialEndTime();
			if (currentTime > this.maxWatchedTime && currentTime <= endTime) {
				this.maxWatchedTime = currentTime;
			}
			if (currentTime >= endTime) {
				this.trialStopped = true;
				this.isResettingSeek = true;
				this.player.currentTime(endTime);
				this.player.pause();
				this.showWatchTip = true;
				setTimeout(() => {
					this.isResettingSeek = false;
				}, 100);
			}
		},
		preventSeek() {
			if (!this.player || this.isResettingSeek) {
				return;
			}
			var currentTime = this.player.currentTime();
			var endTime = this.getTrialEndTime();
			if (currentTime > this.maxWatchedTime + 0.8 || currentTime < this.trialStartTime - 0.5 || currentTime > endTime) {
				var safeTime = Math.min(Math.max(this.maxWatchedTime, this.trialStartTime), endTime);
				this.isResettingSeek = true;
				this.player.currentTime(safeTime);
				setTimeout(() => {
					this.isResettingSeek = false;
				}, 100);
			}
		},
		preventTrialReplay() {
			if (!this.player || !this.trialStopped) {
				return;
			}
			this.player.pause();
			this.player.currentTime(this.getTrialEndTime());
		},
		getOpeningAdSeconds(url) {
			return fetch(url, {
				cache: "no-cache",
			}).then(response => response.text()).then(text => {
				var mediaUrl = this.getMediaPlaylistUrl(url, text);
				if (!mediaUrl) {
					return text;
				}
				return fetch(mediaUrl, {
					cache: "no-cache",
				}).then(response => response.text());
			}).then(text => {
				return this.parseOpeningAdSeconds(text);
			});
		},
		getMediaPlaylistUrl(baseUrl, text) {
			var lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
			for (var i = 0; i < lines.length; i++) {
				if (lines[i].indexOf("#EXT-X-STREAM-INF") === 0) {
					for (var j = i + 1; j < lines.length; j++) {
						if (lines[j].indexOf("#") !== 0) {
							return this.toAbsoluteUrl(baseUrl, lines[j]);
						}
					}
				}
			}
			return null;
		},
		parseOpeningAdSeconds(text) {
			var seconds = 0;
			var lines = text.split(/\r?\n/);
			for (var i = 0; i < lines.length; i++) {
				var line = lines[i].trim();
				if (line.indexOf("#EXT-X-DISCONTINUITY") === 0) {
					return seconds > 0 && seconds <= 90 ? seconds : 0;
				}
				if (line.indexOf("#EXTINF:") === 0) {
					var value = parseFloat(line.replace("#EXTINF:", "").split(",")[0]);
					if (!isNaN(value)) {
						seconds += value;
					}
				}
			}
			return 0;
		},
		toAbsoluteUrl(baseUrl, path) {
			if (/^https?:\/\//i.test(path)) {
				return path;
			}
			var url = new URL(baseUrl);
			if (path.indexOf("/") === 0) {
				return url.origin + path;
			}
			return baseUrl.replace(/\/[^/]*$/, "/") + path;
		},
		tovideo(id) {
			this.$router.push("/vplay/" + id);
		},
		video(id) {
			if (this.player) {
				this.player.pause();
			}
			Fetch("/user/video", {
				id: id,
			}).then(res => {
				this.data = res.data.vedio;
				this.list = res.data.list;
				this.$nextTick(() => {
					this.setVideoSource(this.data.url);
				});
			});
		},
		start() {
			this.video(this.$router.history.current.params.code);
		},
	},
};
</script>

<style lang="less" scoped>
.play-page {
	--accent: #ff5d7a;
	--accent-strong: #ff4f70;
	--accent-soft: #fff1f5;
	--accent-line: #ffdbe4;
	--text: #16223a;
	--muted: #5d677a;
	--card-shadow: 0 12px 28px rgba(255, 93, 122, 0.13);
	--soft-shadow: 0 10px 22px rgba(184, 35, 64, 0.16);
	min-height: 100vh;
	background: linear-gradient(180deg, #ff748f 0%, #ff5574 100%);
	color: var(--text);
	padding-bottom: 84px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: transparent;
	color: #fff;
	border-bottom: 0;
	box-sizing: border-box;
	box-shadow: none;

	.back_left {
		filter: brightness(0) invert(1);
		opacity: 1;
	}

	.big_tit {
		top: 0;
		right: 44px;
		left: 44px;
		width: auto;
		max-width: none;
		height: 44px;
		transform: none;
		color: #fff;
		font-size: 12px;
		line-height: 44px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

.movie-content {
	overflow-y: auto;
	padding: 0px 0 64px;
}

.player-card,
.movie-descript,
.movie-body {
	margin: 3px 16px 0;
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: #fff;
	box-shadow: var(--card-shadow);
	box-sizing: border-box;
}

.player-card {
	overflow: hidden;
	padding: 6px;
	border-color: rgba(255, 255, 255, 0.36);
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.06) 100%);
	box-shadow: var(--soft-shadow);
}

.movie-descript {
	padding: 14px 16px;
	background: rgba(255, 255, 255, 0.96);
}

.video-name {
	margin-bottom: 10px;
	color: var(--accent-strong);
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	word-break: break-word;
}

.play-pill {
	max-width: 100%;
	padding: 6px 12px;
	display: inline-flex;
	align-items: center;
	border-radius: 16px;
	border: 1px solid var(--accent-line);
	background: var(--accent-soft);
	color: var(--accent-strong);
	font-size: 12px;
	font-weight: 700;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.play-pill .van-icon {
	margin-right: 5px;
	font-size: 15px;
}

.movie-body {
	padding: 16px;
	background: linear-gradient(180deg, #fff 0%, #fff8fa 100%);
}

.movie-title {
	display: flex;
	align-items: center;
	color: var(--text);
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
}

.movie-title .van-icon {
	margin-right: 8px;
	color: var(--accent);
	font-size: 18px;
}

.hotlist {
	margin-top: 12px;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.hot-card {
	position: relative;
	overflow: hidden;
	border-radius: 12px;
	border: 1px solid rgba(255, 219, 228, 0.78);
	background: #fff;
	box-shadow: 0 8px 18px rgba(255, 93, 122, 0.12);
	aspect-ratio: 1 / 1.05;
	box-sizing: border-box;
}

.hot-card img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
}

.hot-meta {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	min-height: 32px;
	padding: 0 9px;
	display: flex;
	align-items: center;
	background: linear-gradient(180deg, rgba(22, 34, 58, 0) 0%, rgba(22, 34, 58, 0.82) 100%);
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	box-sizing: border-box;
}

.hot-meta .van-icon {
	color: #ff7892;
}

.hot-meta span {
	min-width: 0;
	margin-left: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.video-js /deep/ .vjs-progress-control {
	display: none;
	pointer-events: none;
}

.video-js /deep/ .vjs-remaining-time,
.video-js /deep/ .vjs-duration,
.video-js /deep/ .vjs-current-time,
.video-js /deep/ .vjs-time-divider {
	display: none;
}

/deep/ .video-js {
	width: 100%;
	background: #111;
	border-radius: 10px;
	overflow: hidden;
}

/deep/ .video-js .vjs-big-play-button {
	top: 50%;
	left: 50%;
	margin-top: -23px;
	margin-left: -45px;
	border: 1px solid rgba(255, 255, 255, 0.52);
	background: rgba(255, 93, 122, 0.78);
	color: #fff;
	box-shadow: 0 10px 24px rgba(255, 93, 122, 0.28);
}

/deep/ .video-js .vjs-control-bar {
	background: linear-gradient(180deg, rgba(22, 34, 58, 0) 0%, rgba(22, 34, 58, 0.88) 100%);
}

/deep/ .video-js .vjs-play-progress,
/deep/ .video-js .vjs-volume-level {
	background: var(--accent);
}

.watch-mask {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 2000;
	width: 100%;
	height: 100%;
	padding: 0 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(22, 34, 58, 0.58);
	backdrop-filter: blur(3px);
	box-sizing: border-box;
}

.watch-dialog {
	width: 100%;
	max-width: 360px;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(255, 255, 255, 0.54);
	background: #fff;
	box-shadow: 0 18px 35px rgba(184, 35, 64, 0.22);
}

.watch-title {
	position: relative;
	min-height: 48px;
	padding: 0 48px 0 18px;
	display: flex;
	align-items: center;
	background: linear-gradient(180deg, #ff7892 0%, #ff5574 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	box-sizing: border-box;
}

.watch-title span {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.watch-close {
	position: absolute;
	top: 8px;
	right: 12px;
	width: 32px;
	height: 32px;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.18);
	color: #fff;
	font-size: 17px;
	font-weight: 700;
	line-height: 32px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.watch-content {
	padding: 16px 18px 18px;
	color: var(--muted);
	font-size: 14px;
	line-height: 22px;
	word-break: normal;
}

@media screen and (max-width: 374px) {
	.player-card,
	.movie-descript,
	.movie-body {
		margin-right: 12px;
		margin-left: 12px;
	}

	.movie-body {
		padding-right: 12px;
		padding-left: 12px;
	}

	.hotlist {
		gap: 10px;
	}
}
</style>
